
import BaseAnimateSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/base-animate-symbol-behaviour";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";

export default class AnimateBehindSymbolBehaviour extends BaseAnimateSymbolBehaviour {

    public behaviourName: string = "AnimateBehind";

    /**
     * Animate over top of a symbol
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAniamtion="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "win_behind") {
        super(symbol, defaultAnimation);

        this.ANIMATE_BEHIND = true;
    }

    public highlight(): Contract<void> {
        return this.animate(["_highlight_behind", "_behind"], ["highlight_" + this.defaultAnimation, this.defaultAnimation]);
    }

    public win(): Contract<void> {

        return this.animate("_behind", [this.defaultAnimation]);
    }

    public cycle(): Contract<void> {

        return this.animate("_behind", [this.defaultAnimation]);
    }
}
